// extracted by mini-css-extract-plugin
export default {"Coupon":"Checks_Coupon__8nxtd"};